import { render, staticRenderFns } from "./ReplicaFormulationPopUp.vue?vue&type=template&id=411f1989&scoped=true&"
import script from "./ReplicaFormulationPopUp.vue?vue&type=script&lang=js&"
export * from "./ReplicaFormulationPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ReplicaFormulationPopUp.vue?vue&type=style&index=0&id=411f1989&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411f1989",
  null
  
)

export default component.exports